/* iter102 — Mobile shell around MyAbsences for PIN-based staff
 * (teachers, canteen, transport) who never see the desktop sidebar. */
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../contexts/AuthContext';
import MyAbsences from '../MyAbsences';

const HOME = {
  teacher_user: '/m/teacher/home',
  cantine_staff: '/m/cantine',
  transport_staff: '/m/driver',
  vigil: '/security',
};

const MobileMyAbsences = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const back = HOME[user?.role] || '/';
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="mobile-my-absences">
      <header className="sticky top-0 z-10 bg-white border-b border-[#E2E8F0] px-3 h-14 flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={() => navigate(back)} data-testid="mobile-my-absences-back">
          <ArrowLeft size={18} />
        </Button>
        <div>
          <p className="font-outfit font-bold text-[#0F172A] leading-tight">Mes absences</p>
          <p className="text-xs text-[#64748B]">{user?.name}</p>
        </div>
      </header>
      <MyAbsences />
    </div>
  );
};

export default MobileMyAbsences;
